export default {
	name: 'custom-tag',
	path: '/custom-tag',
	redirect: '/custom-tag/label-management',
	meta: {
		title: '自定义标签',
		icon: 'custom-tag'
	},
	children: [
		{
			name: 'label-management',
			path: 'label-management',
			fullPath: '/custom-tag/label-management',
			meta: {
				title: '标签管理'
			},
			component: () =>
				import(/* webpackChunkName: "school-label-management" */ '@/views/custom-tag/label-management')
		},
		{
			name: 'label-details',
			path: 'label-details',
			fullPath: '/custom-tag/label-details',
			meta: {
				title: '标签详情'
			},
			component: () =>
				import(/* webpackChunkName: "school-label-management" */ '@/views/custom-tag/label-details')
		},
		{
			name: 'add-members',
			path: 'add-members',
			fullPath: '/custom-tag/add-members',
			meta: {
				title: '添加成员'
			},
			component: () =>
				import(/* webpackChunkName: "school-label-management" */ '@/views/custom-tag/add-members')
		},
		{
			name: 'batch-Import',
			path: 'batch-Import',
			fullPath: '/custom-tag/batch-Import',
			meta: {
				title: '批量导入'
			},
			component: () =>
				import(/* webpackChunkName: "school-label-management" */ '@/views/custom-tag/batch-Import')
		}
	]
};
